export default "__VITE_ASSET__BKQc7KTd__"